<header class="animated fadeInDown top-header" id="navbar">
  <div class="clearfix"></div>
  <div id="skip_to_main"></div>
  <div class="mainHeader">
    <div class="container-fluid">
      <div class="row">
        <div class="col-6 col-sm-6 text-left">
          <div
            role="banner"
            tabindex="0"
            target="_blank"
            class="govindia"
            aria-label="MINISTRY OF HEALTH AND FAMILY WELFARE"
          >
            <span>
              <a href="https://www.mohfw.gov.in" target="_blank">
                <img
                  src="assets/images/emblem-gov.svg"
                  alt="emblem"
                  class="logo1"
                />
              </a>
            </span>
            <span _ngcontent-smi-c21="" class="mainTitle">
              <a
                href="https://www.mohfw.gov.in"
                target="_blank"
                class="accessibility-plugin-ac"
                title="Ministry of Health and Family Welfare"
                >Ministry of Health and Family Welfare</a
              >
            </span>
          </div>
        </div>
        <div class="col-6 col-sm-6 text-right ml-auto my-auto matSelectUL">
          <ul class="access-navigation" role="menu">
            <li
              class="accessibility-plugin-ac accessibilityNewStyle nomob"
              role="link"
              tabindex="0"
              aria-label="Accessibility Settings"
            >
              <div class="accessibility">
                <button
                  title="Increase font size"
                  (click)="changeFontSize($event)"
                  id="increase-plugin-ac"
                  [disabled]="maxFontSizeAllowed > 4"
                  class="inBtn"
                >
                  A +
                </button>
                <button
                  href="javascript:void(0);"
                  title="Reset font size"
                  (click)="changeFontSize($event)"
                  id="normal-plugin-ac"
                  class="inBtn"
                >
                  A
                </button>
                <button
                  href="javascript:void(0);"
                  title="Decrease font size"
                  (click)="changeFontSize($event)"
                  id="decrease-plugin-ac"
                  [disabled]="minFontSizeAllowed > 4"
                  class="inBtn"
                >
                  A -
                </button>
              </div>
            </li>
            <!-- <li
              class="app-lang onlyMobile"
              tabindex="0"
              aria-label="Regional language"
              [attr.aria-label]="'Regional Languages' | translate"
              accesskey="l"
              title="{{ 'HEADER.Regional_Languages' | translate }}"
            >
              <app-language></app-language>
            </li> -->
            <li
              class="fontsBtn mobile-hide"
              tabindex="0"
              aria-label="Increase font size"
            >
              <button
                (click)="changeFontSize($event)"
                id="increase-plugin-ac"
                [disabled]="maxFontSizeAllowed > 4"
              >
                A +
              </button>
            </li>
            <li
              class="fontsBtn mobile-hide Abtn"
              tabindex="0"
              aria-label="Reset font size"
            >
              <button
                href="javascript:void(0);"
                (click)="changeFontSize($event)"
                id="normal-plugin-ac"
              >
                A
              </button>
            </li>
            <li
              class="fontsBtn mobile-hide marginRight15px"
              tabindex="0"
              aria-label="Decrease font size"
            >
              <button
                href="javascript:void(0);"
                (click)="changeFontSize($event)"
                id="decrease-plugin-ac"
                [disabled]="minFontSizeAllowed > 4"
              >
                A -
              </button>
            </li>
            <!-- <li
              class="app-lang mobile-hide"
              tabindex="0"
              aria-label="Regional language"
              [attr.aria-label]="'Regional Languages' | translate"
              accesskey="l"
            >
              <app-language></app-language>
            </li> -->
          </ul>
          <div
            class="app-lang onlyMobile"
            tabindex="0"
            aria-label="Regional language"
            [attr.aria-label]="'Regional Languages' | translate"
            accesskey="l"
            title="{{ 'HEADER.Regional_Languages' | translate }}"
          >
            <app-language></app-language>
          </div>

          <div
            class="app-lang mobile-hide"
            tabindex="0"
            aria-label="Regional language"
            [attr.aria-label]="'Regional Languages' | translate"
            accesskey="l"
          >
            <app-language></app-language>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="midCenterCol">
    <div class="container-fluid">
      <div class="row leftPart d-flex align-items-center">
        <!-- <div class="col-12 pr-md-0"> -->
        <div class="col-12 pr-md-0">
          <!-- <div
              role="banner"
              tabindex="0"
              target="_blank"
              class="govindia"
              aria-label="MINISTRY OF HEALTH AND FAMILY WELFARE"
            >
              <span
                ><img
                  src="assets/images/emblem-gov.svg"
                  alt="emblem"
                  class="logo1" /></span
              ><span _ngcontent-smi-c21="" class="mainTitle"
                ><a
                  href="https://www.india.gov.in/"
                  target="_blank"
                  class="accessibility-plugin-ac"
                  title="Ministry of Health and Family Welfare"
                  >Ministry of Health and Family Welfare</a
                ></span
              >
            </div> -->

          <!-- <div
              class="app-lang onlyMobile no-desktop mlang"
              tabindex="0"
              aria-label="Regional language"
              [attr.aria-label]="'Regional Languages' | translate"
              accesskey="l"
              title="{{ 'HEADER.Regional_Languages' | translate }}"
            >
              <app-language></app-language>
            </div> -->

          <nav class="navbar navbar-expand-lg">
            <!-- <div class="noDesktop">
              <div class="loginBtnMobile">
                <a
                  href="{{ urls.selfReg }}{{
                    currLang != 'en' ? '?lang=' + currLang : ''
                  }}"
                  target="_blank"
                  role="button"
                  aria-pressed="true"
                >
                  {{ "HEADER.REGISTER_SIGN_IN_YOURSELF" | translate }}
                </a>
              </div>
            </div> -->
            <div
              role="banner"
              tabindex="0"
              [attr.aria-label]="'Logo' | translate"
              class="logoArea noMobile"
            >
              <a href="{{ urls.mainPage + '/' }}" target="_blank">
                <div role="img" class="Mobile emblem-logo2">
                  <img
                    class="logo2"
                    src="../../../../../assets/images/new-logo.svg"
                    alt="Co-WIN"
                    title="{{ 'Co-WIN' | translate }}"
                  />
                </div>
              </a>

              <!-- <span class="mobileloginbtn">
                                <a href="{{urls.selfReg}}{{currLang != 'en' ? '?lang=' + currLang : ''}}"
                                    target="_blank" role="button" aria-pressed="true" class="yellowloginbtn">
                                    {{'HEADER.REGISTER_SIGN_IN_YOURSELF' | translate}}
                                    <span class="hinditextHide">लॉग इन करें</span>
                                </a>
                            </span> -->
            </div>
            <div
              role="banner"
              tabindex="0"
              class="logoArea noDesktop"
              aria-label="CoWIN"
            >
              <a href="{{ urls.mainPage + '/' }}" target="_blank">
                <div role="img" class="emblem-logo2">
                  <img
                    class="logo2"
                    src="../../../../../assets/images/new-logo.svg"
                    alt="Co-WIN"
                    title="{{ 'Co-WIN' | translate }}"
                  />
                </div>
              </a>
            </div>
            <!-- Desktop nav-->
            <div
              role="navigation"
              aria-label="Menu"
              class="menunavigation noMobile"
            >
              <ul class="menuItemCenter">
                <li tabindex="0" class="accessibility-plugin-ac">
                  <a
                    href="{{ urls.verifyCertificate }}"
                    target="_blank"
                    role="button"
                    class="dropdwnbtn accessibility-plugin-ac newMenu abhaanchortag"
                  >
                    {{ "HEADER.VERIFY_CERTIFICATE" | translate }}
                  </a>
                </li>
                <li tabindex="0" class="accessibility-plugin-ac">
                  <a
                    href="{{ urls.mainPage + '/faq' }}"
                    role="button"
                    target="_blank"
                    class="dropdwnbtn accessibility-plugin-ac newMenu abhaanchortag"
                  >
                    {{ "HEADER.FAQ" | translate }}
                  </a>
                </li>
              </ul>
            </div>
            <!-- //Desktop nav-->
            <div class="noDesktop">
              <!-- Mobile nav-->
              <div class="navIconPan">
                <!-- <a href="#" class="mt-2"><img src="../../../../../assets/images/search.svg"></a> -->
                <button
                  class="hamburgerBtn newhamburgerBtn"
                  mat-button
                  [matMenuTriggerFor]="mobileNav"
                >
                  <i class="hamburgerIcon1"></i>
                  <i class="hamburgerIcon2"></i>
                  <i class="hamburgerIcon3"></i>
                </button>
                <mat-menu #mobileNav="matMenu">
                  <a
                    mat-menu-item
                    href="{{ urls.verifyCertificate }}"
                    target="_blank"
                    role="button"
                    class="dropdwnbtn accessibility-plugin-ac newMenu anchortag"
                    >Verify Certificate
                  </a>
                  <a
                    mat-menu-item
                    href="https://www.cowin.gov.in/faq"
                    role="button"
                    target="_blank"
                    class="dropdwnbtn accessibility-plugin-ac newMenu anchortag"
                    >FAQ
                  </a>

                  <!-- <button class="link-item-top" mat-menu-item
                                          [matMenuTriggerFor]="support">{{'HEADER.Support' |
                                          translate}}</button> -->
                </mat-menu>
              </div>
              <!-- //Mobile nav-->
            </div>
          </nav>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
  <div class="clearfix"></div>
</header>
